export default __webpack_public_path__ + "static/media/pdf.985c1482.svg";